export default __webpack_public_path__ + "static/media/double-both-border-none.f7aa5ebb.svg";